import starterIMG from '../assets/images/starter.svg';
import professionalIMG from '../assets/images/professional.svg';

const BACKCARDS = {
  1: {
    title: 'SHIFT Comms',
    description: 'Internal Communications + Engagement',
    priceText: 'Starting $50/mo',
    keyFeature: 'Key Features:',
    checklistP: [
      'Improve Employee Communication',
      'Boost Employee Productivity',
      'Increase Operational Excellence',
      'Highlight and Recognize Team Members',
      'Strengthen Team Camaraderie',
      'Amplify Training Material Visibility',
    ],
    buttonLabel: 'Book a demo',
    icon: starterIMG,
  },
  2: {
    title: 'SHIFT Comms + Data',
    description: 'Internal Communications + Engagement + Data',
    priceText: 'Custom Pricing',
    keyFeature: 'Everything included in SHIFT Comms Plus:',
    checklistP: [
      'Display Real-Time Data with Custom POS Integrations',
      'Automate Employee Recognition (Birthdays, Anniversaries)',
      'Launch productivity-boosting contests (store-vs-store, product sales contests, etc)',
      'Highlight Customer Satisfaction',
    ],
    buttonLabel: 'Book a demo',
    icon: professionalIMG,
  },
};

export default BACKCARDS;
